import { Box, Container, Typography } from "@mui/material";
import globalStyles from "../../global";
import FranchiseForm from "../FranchiseForm";
import { useTranslation } from "react-i18next";

const ApplyFranchise = () => {
  const { t } = useTranslation();
  const styles = {
    heroContainer: {
      width: "100%",
      height: { xs: "280px", sm: "440px", md: "500px" }, // updated
      position: "relative",
      overflow: "hidden",
    },
    heroImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 1,
    },
    heroContent: {
      position: "relative",
      zIndex: 2,
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      px: 2,
    },
    heroTitle: {
      fontFamily: "AllRoundGothicBold",
      fontWeight: 400,
      lineHeight: "60px",
      letterSpacing: "1%",
      textTransform: "uppercase",
      fontSize: { md: "45px", sm: "30px", xs: "26px" },
      color: "#ffffff",
      maxWidth: "770px",
    },
  };
  return (
    <Box>
      <Box sx={styles.heroContainer}>
        <Box
          component="img"
          src={`${process.env.REACT_APP_IMAGE_BASE_URL}ContactBanner.svg`}
          alt="Privacy Banner"
          sx={styles.heroImage}
        />
        <Container maxWidth="lg" sx={{ height: "100%", position: "relative" }}>
          <Box sx={styles.heroContent}>
            <Typography sx={styles.heroTitle}>
              {t("event.contactUsTitle")}
            </Typography>
          </Box>
        </Container>
      </Box>

      <Container sx={{ py: 8 }}>
        <Box
          sx={{
            width: "100%",
            maxWidth: "1200px",
            mx: "auto",
          }}
        >
          <Typography
            sx={[
              styles.typography,
              {
                 fontSize: { md: "45px", sm: "30px", xs: "20px" },
                fontFamily: " AllRoundGothicBold, serif ",
                textTransform: "uppercase",
                color: globalStyles.colors.army_green,
                fontWeight: 400,
                lineHeight: "100%",
                letterSpacing: "1%",
                mb: 1,
              },
            ]}
          >
            {t("applyFranchise.title")}
          </Typography>
          <Typography
            sx={{
              fontFamily: "'Poppins'",
              fontWeight: 400,
            fontSize: { sm: "18px", xs: "14px" },
              lineHeight: "auto",
              letterSpacing: "1%",
              textAlign: "justify",
              color: "#666666",
              mb: 2,
            }}
          >
            {t("applyFranchise.description")}
          </Typography>
        </Box>
        <FranchiseForm />
      </Container>
      <Box sx={styles.box3} />
    </Box>
  );
};

export default ApplyFranchise;
